import { useSelector, useDispatch } from "react-redux";
import { useEffect, useState, useCallback } from "react";
import { useAppDispatch, useAppSelector } from "../../../../../redux";
import { useRemirrorContext } from "@remirror/react";
import overlaySlice, { closeOverlay, openOverlay } from "../../../../../layouts/Overlay/overlaySlice";
import { getImagesAroundPosition } from "../../utils/getImagesAroundPosition";
import { Node, NodeType } from "@remirror/pm/dist-types/model";
import VideoSlider from "./VideoSlider";
import { saver } from "../../../../../network/saver";
import { selectGuidePreview } from '../../../../../redux/slices/guideSlice';
// Import other hooks if necessary

const useAddScreenshot = () => {
    const dispatch = useAppDispatch();
    const guidePreview = useAppSelector(selectGuidePreview)
    const {commands, manager} = useRemirrorContext()
    // Define the command to insert the screenshot
    const insertScreenshot = async (uri: string, timestamp: number)=>{
        //@ts-ignore
        const resp = await saver.uploadImage(guidePreview?.id, uri )
        const node: Node = manager.schema.nodes.image.create({
            src: uri,
            metadata: {
                timestamp: timestamp,
                s3ObjectId: resp
            }
        })
        commands.insertNode(node)
        dispatch(closeOverlay())
    }
    // Retrieve original source from the current guide
    // Define original timestamps based on cursor position and existing screenshots
    const src = useAppSelector(state=>state.guide.value.guide?.guideData.video.src) as string

    // Pass to component
    
    return ()=>{
        const pos = (manager.view.state.selection)
        const {start, end} = getImagesAroundPosition(pos.from, manager.view.state.doc)
        dispatch(openOverlay({
            heading: {
                icon: null,
                title: "Add Screenshot",
                data: "" , 
            },
            component: <VideoSlider
                source={src}
                initialStartTimestamp = {start}
                initialEndTimestamp={end}
                addImage={insertScreenshot}
            />
        }))
    };
};

export default useAddScreenshot;
